export default __webpack_public_path__ + "static/media/1879.69fff850.png";